import React, {Component} from "react"
import { Form, InputGroup, Button } from "react-bootstrap"
import MaskedInput from "react-maskedinput"
import { FaCalendarAlt } from "react-icons/fa"

interface BirthdayInputProps {
  required?: boolean
  isInvalid?: boolean
  placeholder?: string
  value?: string
  onClick?: () => void
  onChange?: () => void
}

export class BirthdayInput extends Component<BirthdayInputProps> {
  render() {
    return (
      <InputGroup>
        <Form.Control
          {...this.props}
          type="text"
          placeholder="MM/DD/YYYY"
          mask="11/11/1111"
          onClick={() => {}}
          isInvalid={this.props.isInvalid || (this.props.required && !this.props.value)}
          as={MaskedInput}
          />
        <InputGroup.Append>
          <Button className="btn-rounded-right" onClick={this.props.onClick}>
            <FaCalendarAlt />
          </Button>
        </InputGroup.Append>
      </InputGroup>
    )
  }
}
